import axios, { AxiosError, AxiosResponse } from 'axios';

import { store } from '@/store';
import { router } from '@/router';
import { i18n } from '@/i18n';
import VueI18n from 'vue-i18n';

/** The axios instance */
const instance = axios.create({
	withCredentials: false,
	baseURL: window.API_URL,
	headers: {
		'Accept': 'application/json',
		'Content-Type': 'application/json'
	}
});
const instance_oauth = axios.create({
	withCredentials: false,
	baseURL: window.API_URL_OAUTH,
	headers: {
		'Accept': 'application/json',
		'Content-Type': 'application/json'
	}
});

/** Default error message */
const DEFAULT_ERROR_MESSAGE_KEY = 'common.defaultErrorMessage';

function error(error: AxiosError) {
	let errorMessage: VueI18n.TranslateResult = i18n.t(DEFAULT_ERROR_MESSAGE_KEY);

	if (!error.response) {
		// Use the default message
		errorMessage = i18n.t(DEFAULT_ERROR_MESSAGE_KEY);
	} else if (error.response.status === 401) {
		// If we have a 401 HTTP Code, redirect to login
		store.dispatch('appState/logout');
		if (router.currentRoute.path !== '/login') {
			router.push('/login');
		}
		errorMessage = i18n.t('common.defaultUnauthorizedMessage');
	} else if (error.response?.data['hydra:description'] || error.response?.data['detail']) {
		errorMessage = error.response?.data['hydra:description'] || error.response?.data['detail'];
	} else {
		errorMessage = i18n.t(DEFAULT_ERROR_MESSAGE_KEY);
	}

	store.dispatch('notification/add', {
		type: 'error',
		message: errorMessage
	});

	return Promise.reject(error);
}

// Response interceptor to handle errors globally
instance.interceptors.response.use(undefined, error);
instance_oauth.interceptors.response.use(undefined, error);

export { instance as axios };
export { instance_oauth as axios_oauth };
export { AxiosResponse };
